import { getMonthToDateRange } from '@/utils/date';
import {
  FILTER_KEYS,
  parseNumberFilter,
  toFilterText,
  toPeriodFilterValues,
  toPeriodSearch,
} from '@/utils/filters';
import type { ZonalStatementListSearch, ZonalStatementSearch } from '../types/zonalStatement.types';

type ZonalStatementFilterSearch = Pick<
  ZonalStatementSearch,
  'dateFrom' | 'dateTo' | 'divisionId' | 'districtId'
>;

export function toZonalStatementFilterValues(
  search: ZonalStatementFilterSearch,
): Record<string, string> {
  return {
    ...toPeriodFilterValues(search, getMonthToDateRange()),
    [FILTER_KEYS.divisionId]: toFilterText(search.divisionId),
    [FILTER_KEYS.districtId]: toFilterText(search.districtId),
  };
}

export function toZonalStatementFilterSearch(
  values: Record<string, string>,
): ZonalStatementFilterSearch {
  return {
    ...toPeriodSearch(values),
    divisionId: parseNumberFilter(values[FILTER_KEYS.divisionId]),
    districtId: parseNumberFilter(values[FILTER_KEYS.districtId]),
  };
}

export function toZonalStatementDrillSearch({
  search: _search,
  ...drillSearch
}: ZonalStatementListSearch): ZonalStatementSearch {
  return drillSearch;
}
